import React, { useEffect, useState } from 'react'
import { getallCampaign } from '../Common/apis';
import { toast } from 'react-toastify';
import moment from 'moment/moment';
import Loader from '../Components/Loader/Loader';


function Campaign() {
    const [cBtn, setCBtn] = useState("All");
    const [allCampaign, setAllCampaign] = useState(null)
    const [loading, setLoading] = useState(false);


    const fetchCampaign = async () => {
        setLoading(true);
        try {
            const response = await getallCampaign();
            setAllCampaign(response.data);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchCampaign();
    }, []);


    return (
        <>
            {loading && <Loader />}
            <div className='mt-[80px]'>
                <div className='pt-[50px] md:px-[110px] px-[20px]'>
                    <h6 className="text-center max-w-[572px] w-full mx-auto text-heading-primary text-[#2D190D] pb-[50px]">Campaign</h6>
                    <div className='flex items-center gap-[8px] mb-[50px]'>
                        <button onClick={() => setCBtn("All")} className={`${cBtn === "All" ? "text-[#FFFFFF] border-[#FF6000]" : "text-[#FF6000]"} font-[400] border-[1px] font-manrope px-[12px] py-[14px] rounded-full`} style={{ background: cBtn === "All" ? "linear-gradient(180deg, #FF6000 0%, #F68B29 100%)" : "unset" }}>All</button>
                        <button onClick={() => setCBtn("OnGoing")} className={`${cBtn === "OnGoing" ? "text-[#FFFFFF] border-[#FF6000]" : "text-[#FF6000]"} font-[400] border-[1px] font-manrope px-[12px] py-[14px] rounded-full`} style={{ background: cBtn === "OnGoing" ? "linear-gradient(180deg, #FF6000 0%, #F68B29 100%)" : "transparent" }}>Ongoing (0)</button>
                        <button onClick={() => setCBtn("Success")} className={`${cBtn === "Success" ? "text-[#FFFFFF] border-[#FF6000]" : "text-[#FF6000]"} font-[400] border-[1px] font-manrope px-[12px] py-[14px] rounded-full`} style={{ background: cBtn === "Success" ? "linear-gradient(180deg, #FF6000 0%, #F68B29 100%)" : "transparent" }}>Success (1)</button>
                    </div>
                    <div className="grid md:grid-cols-2 md:pb-[160px] pb-[40px] grid-cols-1 gap-x-[42px] gap-y-[30px]">
                        {allCampaign?.map((item) => {
                            const today = moment();
                            const endDate = moment(item?.CampaignEndDate);
                            const startDate = moment(item?.CampaignStartDate);

                            let daysLeft = 0;

                            if (today.isBefore(startDate)) {
                                // Campaign hasn't started
                                daysLeft = endDate.diff(startDate, 'days');
                            } else {
                                // Ongoing campaign or ended
                                daysLeft = Math.max(endDate.diff(today, 'days'), 0);
                            }

                            return (
                                <div key={item.id} className="flex flex-col gap-[30px] w-full">
                                    <div className='flex gap-[13px] flex-row items-start w-full'>
                                        <img src={item?.Image} className='h-[114px] max-w-[156px] w-full rounded-[8px]' alt="" />
                                        <div className='w-full'>
                                            <div className="flex justify-between items-center w-full">
                                                <p className="font-[600] font-manrope text-[16px] text-[#4D4D4D]">{item?.CampaignerName}</p>
                                                <p className="font-[400] font-manrope text-[16px] text-[#4D4D4D]">
                                                    {moment(item?.CampaignStartDate).format('MMMM D, YYYY')}
                                                </p>
                                            </div>
                                            <h6 className="pt-[5px] font-[700] font-manrope text-[20px] text-[#333333]">{item?.CampaignName}</h6>

                                            <input
                                                type="range"
                                                min="0"
                                                max={item?.TotalRequiredDonation}
                                                value={item?.ReceivedDonation}
                                                className="w-full accent-[#FF6000]"
                                                readOnly
                                            />

                                            <div className='flex justify-between items-center'>
                                                <div>
                                                    <p className="font-[400] font-manrope text-[11px] text-[#666666]">Raised</p>
                                                    <h6 className="font-[700] font-manrope text-[20px] text-[#141414]">
                                                        ₹{item?.ReceivedDonation}
                                                    </h6>
                                                </div>
                                                <div>
                                                    <p className="font-[400] font-manrope text-right text-[11px] text-[#666666]">Days left</p>
                                                    <h6 className="font-[700] font-manrope text-right text-[20px] text-[#141414]">
                                                        {daysLeft}
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='flex justify-between items-center'>
                                        <div className='flex gap-[12px] items-center'>
                                            <button className='flex items-center gap-[8px]'>
                                                <img src="/assets/impact/edit.svg" alt="" />
                                                <p className="font-[400] font-manrope text-[16px] text-[#2B2B2B]">Edit</p>
                                            </button>
                                            <button className='flex items-center gap-[8px]'>
                                                <img src="/assets/impact/share.svg" alt="" />
                                                <p className="font-[400] font-manrope text-[16px] text-[#2B2B2B]">Share</p>
                                            </button>
                                        </div>
                                        <button className='d-btn !capitalize'>See results</button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Campaign